// A labelled on/off switch on its own row (same look as the other toggles in the app).
// Pass `name` + `defaultChecked` for form fields read on submit, or `checked` + `onChange`
// when the parent keeps the value in state.
const ToggleRow = ({
  id,
  name,
  label,
  defaultChecked,
  checked,
  onChange,
  className = '',
}) => {
  const stateProps =
    checked !== undefined ? { checked, onChange } : { defaultChecked }

  return (
    <div className={`d-flex align-items-center ${className}`}>
      <label
        htmlFor={id}
        style={{ minWidth: '52px' }}
        className='custom-toggle mr-2 mb-0'
      >
        <input
          id={id}
          name={name}
          type='checkbox'
          style={{ display: 'none' }}
          {...stateProps}
        />
        <span className='custom-toggle-slider rounded-circle' />
      </label>
      <span className='user-select-none'>{label}</span>
    </div>
  )
}

export default ToggleRow
